import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearSearch", "spinner", "magnifyingGlass", "highlightArea"]

  connect() {
    if (this.hasInputTarget) {
      this.#highlightSearchQuery()
    }
  }

  inputTargetConnected() {
    this.toggleSearchActions()
    this.#highlightSearchQuery()
  }

  focusOnInput(event) {
    const clickedElement = event.target
    const tagName = clickedElement.tagName.toLowerCase()
    const excludedTags = ["input"]

    if (!excludedTags.includes(tagName)) {
      event.preventDefault()
      this.inputTarget.focus()
    }
  }

  toggleSearchActions() {
    if (this.inputTarget.value == "") {
      this.magnifyingGlassTarget.classList.add("text-gray-400")
      this.clearSearchTarget.classList.add("hidden")
    } else {
      this.clearSearchTarget.classList.remove("hidden")
      this.magnifyingGlassTarget.classList.remove("text-gray-400")
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.toggleSearchActions()
    this.#clearAllHighlights()
  }

  submit() {
    this.magnifyingGlassTarget.classList.add("hidden!")
    this.spinnerTarget.classList.remove("hidden!")
  }

  #clearAllHighlights() {
    const highlights = this.highlightAreaTarget.querySelectorAll("mark")
    highlights.forEach(mark => {
      const parent = mark.parentNode
      if (parent) {
        parent.replaceChild(document.createTextNode(mark.textContent || ""), mark)
        parent.normalize()
      }
    })
  }

  #highlightSearchQuery() {
    if (this.inputTarget.value) {
      this.#clearAllHighlights()
      const element = this.highlightAreaTarget
      const query = this.inputTarget.value
      const regex = new RegExp(`(${this.#escapeRegExp(query)})`, "gi")
      const treeWalker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false)

      let currentNode
      const nodesToModify = []

      while ((currentNode = treeWalker.nextNode()) !== null) {
        const text = currentNode.nodeValue
        if (regex.test(text)) {
          nodesToModify.push({node: currentNode, queryRegex: regex})
        }
      }

      nodesToModify.forEach(item => {
        const { node, queryRegex } = item
        const parent = node.parentNode
        if (!parent) return

        const text = node.nodeValue
        const fragment = document.createDocumentFragment()
        let lastIndex = 0
        let match

        queryRegex.lastIndex = 0

        while ((match = queryRegex.exec(text)) !== null) {
          if (match.index > lastIndex) {
            fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)))
          }
          const mark = document.createElement("mark")
          mark.className = this.#highlightClass()
          mark.textContent = match[0]
          fragment.appendChild(mark)
          lastIndex = queryRegex.lastIndex
        }

        if (lastIndex < text.length) {
          fragment.appendChild(document.createTextNode(text.substring(lastIndex)))
        }

        if (fragment.childNodes.length > 0) {
          parent.replaceChild(fragment, node)
        }
      })
    }
  }

  #escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }

  #highlightClass() {
    return "font-semibold"
  }

}
